import '../../shared/config/unpoly.js'
import '../../shared/config/unpoly.sass'
up.link.config.preloadSelectors.push('a[href]')
up.layer.config.drawer.openAnimation = 'move-from-top'
up.layer.config.drawer.closeAnimation = 'move-to-top'
